import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

const getTrustScoreCancelSubmissionAvailability = async () => {
  return await client.get(`/trust_score/check_cancel_submission_availability`, {
    noLoading: true
  })
}

const useGetTrustScoreCancelAvailability = ({ enabled }: { enabled: boolean }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [`trust-score-cancel-availability`],
    queryFn: () => getTrustScoreCancelSubmissionAvailability(),
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 5 * 60000
  })
  return { data, isLoading, refetch }
}

export default useGetTrustScoreCancelAvailability
